import React, { useContext, useMemo, useCallback } from 'react';
import Spreadsheet from 'react-spreadsheet';
import { ChillerCircuit } from '../../model';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

interface EvaporatorDetailsSubsectionProps {
  chillerCircuit: ChillerCircuit;
  col?: number;
}

const EvaporatorDetailsSubsection: React.FunctionComponent<EvaporatorDetailsSubsectionProps> = (props) => {
  let { chillerCircuit, col } = props;

  const { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved } =
    useContext(ChillerLogsContext);

  let classes = 'chiller-spreadsheet';
  if (col === 3) {
    classes += ' third-column';
  }

  const handleSpreadsheetChange = useCallback(
    (updatedData) => {
      updateChillerLogFieldIfChanged({
        chillerLog,
        setChillerLog,
        updatedData,
        currentFieldValue: chillerCircuit.evaporator_details,
        getField: (log) => log.circuits[chillerCircuit.index].evaporator_details,
        setField: (log, value) => {
          log.circuits[chillerCircuit.index].evaporator_details = value;
        },
      });
    },
    [setChillerLog, chillerLog, chillerCircuit],
  );

  let readIndex = chillerCircuit?.index + 1;
  let tableData = useFormattedTableData(chillerCircuit?.evaporator_details, col, currentLogApproved);
  let columnLabels = ['', '', '', `Circuit ${readIndex}`];

  return (
    chillerCircuit?.evaporator_details?.length > 0 && (
      <Spreadsheet
        data={tableData}
        hideRowIndicators
        columnLabels={[columnLabels[col]]}
        onChange={handleSpreadsheetChange}
        className={classes}
        onBlur={saveCurrentLogToLocalStorage}
      />
    )
  );
};

export default EvaporatorDetailsSubsection;
